import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/blacklist/service/data.service';
import { CountryCodesService } from 'src/app/service/country-codes.service';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { InitiateTarriffComponent } from 'src/app/tarriff/dialog/initiate-tarriff/initiate-tarriff.component';

@Component({
  selector: 'app-initiate-whitelist',
  templateUrl: './initiate-whitelist.component.html',
  styleUrls: ['./initiate-whitelist.component.scss']
})
export class InitiateWhitelistComponent implements OnInit {
  uploadWhitelistForm: FormGroup;
  loadPage: boolean;
  whitelistData: [];
  msisdn: any = [];
  imsi: any = [];
  remarks: any = [];
  msgType: any = [];
  fileToUpload: any;
  submitted = false;
  map: Map<string, string>;
  countryCodeCheck = '';

  constructor(private dialogRef: MatDialogRef<InitiateTarriffComponent>,
    private dataService: DataService, private formBuilder: FormBuilder,
    private router: Router, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinnerService: Ng4LoadingSpinnerService,
    private endpointsService: EndpointsService,
    private countryCodesService: CountryCodesService,
    private backendApiService: BackendApiService) {
    this.spinnerService.show();
  }

  ngOnInit(): void {
    this.createWhitelistForm();
    this.loadPage = true;
    this.map = this.countryCodesService.getCountryCodes();
  }

  get f() {
    return this.uploadWhitelistForm.controls;
  }

  createWhitelistForm() {
    this.uploadWhitelistForm = this.formBuilder.group({
      // hpmnCountry: ['', Validators.required],
      msisdn: ['', [Validators.minLength(12), Validators.maxLength(12), Validators.required, Validators.pattern("^[0-9]*$"), this.countryCodeValidator.bind(this)]],
      imsi: ['', [Validators.minLength(15), Validators.maxLength(15), Validators.required, Validators.pattern("^[0-9]*$")]],
      remarks: [''],
      msgType: ['']
    });
  }


  countryCodeValidator(control: FormControl): { [key: string]: boolean } | null {
    if (control.value.length >= 12) {
      let v = control.value + "";
      let countryCode = v.substr(0, 3);
      let country = sessionStorage.getItem('homeCountry').trim();
      this.countryCodeCheck = this.map.get(country);
      if (this.map.get(country)) {
        if (parseInt(countryCode) !== parseInt(this.map.get(country))) {
          return { 'countryCode': true };
        }
      }
    }
    return null;
  }


  conditionalValidator(field: string): ValidatorFn {
    return formControl => {
      if (!formControl.parent) {
        return null;
      }
      const otherControl = formControl.parent.get(field);
      const error =
        formControl.value || otherControl.value
          ? null
          : { error: "this field or " + field + " is required" };
      if ((error && otherControl.valid) || (!error && otherControl.invalid)) {
        setTimeout(() => {
          otherControl.updateValueAndValidity({ emitEvent: false });
        });
      }
      return error;
    };
  }

  onClose() {
    this.dialogRef.close();
  }

  onInsert() {
    this.submitted = true;
    if (this.uploadWhitelistForm.valid) {
      this.spinnerService.show();
      this.backendApiService.callToApi(this.endpointsService.INSERT_WHITELIST +
        '&msisdn=' + this.uploadWhitelistForm.get('msisdn').value +
        '&imsi=' + this.uploadWhitelistForm.get('imsi').value +
        '&remarks=' + this.uploadWhitelistForm.get('remarks').value +
        '&msgType=' + this.uploadWhitelistForm.get('msgType').value +
        '&userOrgId=' + sessionStorage.getItem('userOrgId'))
        .subscribe(response => {
          this.spinnerService.hide();
          if (response) {
            alert('Added successfully');
            this.dialogRef.close();
            this.storeAnalytics();
          } else {
            alert('Not uploaded , already exist');
          }
        });
    }
    
  }

  validateCountryCode(control: AbstractControl): { [key: string]: any } | null {
    const msidn: string = control.value;
    
    if (!msidn && msidn.length > 11) {
      return { 'validateCountryCode': 'this is not a valid country code' };
    }
  }
  // async storeAnalytics() {
  //   const apiUrl1 = this.endpointsService.CENTRY_LOG +
  //     'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=BlackList' + '&module=blacklist' + '&operation=configuration' + '&msisdn='+this.uploadWhitelistForm.get('msisdn').value;
  //   this.backendApiService.callToApi(apiUrl1).subscribe(response => {
  //    console.log(response);
  //   });
  // }
  storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Whitelist' + '&module=whitelist' + '&operation=add_msisdn'+'&opname=msisdn' + '&opvalue=' +  this.uploadWhitelistForm.get('msisdn').value;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });


  }
  
}
